(() => {
  if (customElements.get('ssp-home-kit-explorer')) return;
  customElements.define('ssp-home-kit-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-home-eye]')];
      this.panels = [...this.querySelectorAll('[data-home-eye-panel]')];
      this.onClick = event => {
        const button = event.target.closest('[data-home-eye]');
        if (button && this.contains(button)) this.select(button);
      };
      this.onKey = event => {
        const button = event.target.closest('[data-home-eye]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.tabs.indexOf(button);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(this.tabs[index]);
        this.tabs[index].focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }
    select(button) {
      this.tabs.forEach(tab => {
        const selected = tab === button;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.homeEyePanel !== button.dataset.homeEye; });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.ready = false;
    }
  });
})();
